import { render } from "./Categoria.vue?vue&type=template&id=5bdc3dc4&scoped=true"
import script from "./Categoria.vue?vue&type=script&lang=js"
export * from "./Categoria.vue?vue&type=script&lang=js"

import "./Categoria.vue?vue&type=style&index=0&id=5bdc3dc4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdc3dc4"]])

export default __exports__